import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// assigner des payeurs à un plan de paiement
export const assignPayersToPlan = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/studentPaiement/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les plan de payement d'un étudiant
export const getStudentPaiementPlans = async (
  id_student,
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/studentPaiement/${id_student}/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer en une seule requête tous les plans attribués pour une année
export const getAllStudentPaiementPlansByYear = async (
  id_academicYear,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/studentPaiement/all/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
